import React from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import useToggle from '@lyearn/core/hooks/useToggle';

import { DropOverContainerProps } from './types';

const useDnd = ({
  canDrop,
  onDropCallback,
}: {
  canDrop?: DropOverContainerProps['canDrop'];
  onDropCallback?: DropOverContainerProps['onDrop'];
}) => {
  const [isDragOver, { on, off }] = useToggle(false);

  const onDragOver = useEvent((event: React.DragEvent<HTMLDivElement>) => {
    const isDroppable = canDrop ? canDrop(event) : true;
    if (isDroppable) {
      event.preventDefault();
      on();
    }
  });

  const onDrop = useEvent((event: React.DragEvent<HTMLDivElement>) => {
    off();
    onDropCallback?.(event);
  });

  return {
    onDragOver,
    onDrop,
    isDragOver,
    onDragLeave: off,
  };
};

export default useDnd;
